const API_BASE = '/api'

function buildUrl(path, query) {
  let url = String(path || '')
  if (!url) url = API_BASE
  else if (!/^https?:\/\//i.test(url) && !url.startsWith(API_BASE)) url = `${API_BASE}${url}`
  if (query && typeof query === 'object') {
    const p = new URLSearchParams()
    for (const [k, v] of Object.entries(query)) {
      if (v === undefined || v === null || v === '') continue
      p.append(k, String(v))
    }
    const q = p.toString()
    if (q) url += `${url.includes('?') ? '&' : '?'}${q}`
  }
  return url
}

function parseResponse(p) {
  return p.then((r) => {
    const ct = r.headers.get('content-type') || ''
    if (ct.includes('application/json')) {
      return r.json().then((data) => {
        if (!r.ok) {
          const err = new Error(data?.error || `HTTP ${r.status}`)
          err.status = r.status
          err.data = data
          throw err
        }
        return data
      })
    }
    if (!r.ok) throw new Error(`HTTP ${r.status}`)
    return r.text()
  })
}

function buildHeaders(extra) {
  const h = { 'Content-Type': 'application/json', ...(extra || {}) }
  const token = localStorage.getItem('admin_token')
  if (token) h['Authorization'] = `Bearer ${token}`
  return h
}

export const http = {
  get(path, query) {
    const url = buildUrl(path, query)
    return parseResponse(
      fetch(url, {
        method: 'GET',
        credentials: 'include',
        headers: buildHeaders(),
      })
    )
  },
  post(path, body) {
    return parseResponse(
      fetch(buildUrl(path), {
        method: 'POST',
        credentials: 'include',
        headers: buildHeaders(),
        body: body === undefined ? undefined : JSON.stringify(body),
      })
    )
  },
  patch(path, body) {
    return parseResponse(
      fetch(buildUrl(path), {
        method: 'PATCH',
        credentials: 'include',
        headers: buildHeaders(),
        body: body === undefined ? undefined : JSON.stringify(body),
      })
    )
  },
  put(path, body) {
    return parseResponse(
      fetch(buildUrl(path), {
        method: 'PUT',
        credentials: 'include',
        headers: buildHeaders(),
        body: body === undefined ? undefined : JSON.stringify(body),
      })
    )
  },
  delete(path) {
    return parseResponse(
      fetch(buildUrl(path), {
        method: 'DELETE',
        credentials: 'include',
        headers: buildHeaders(),
      })
    )
  },
}

export function apiPost(path, body, headers) {
  return parseResponse(
    fetch(buildUrl(path), {
      method: 'POST',
      credentials: 'include',
      headers: buildHeaders(headers),
      body: body === undefined ? undefined : JSON.stringify(body),
    })
  )
}
